import React from "react";
import { Carousel } from "react-bootstrap";
import styled from "styled-components";
import { MediaModel } from "../models";
import { Video } from "@mindmemobile/mm-shared-global";
// import dummyImage from './../../images/checkout/carousel-dummy-image.png';

interface CarouselProps {
  media: MediaModel[] | null;
  className?: string;
}

export const CustomCarouselWrapper = styled.div`
  width: 100%;
  height: 200px !important;
  /* overflow: hidden; */
  display: flex;
  justify-content: center;
  align-items: center;

  .carousel.slide {
    height: 100%;
  }

  .carousel-indicators {
    top: unset;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 80%);
    right: unset;
    margin: 0px;
    button {
      height: 15px;
      width: 15px;
      border-radius: 50%;
      background-color: rgba(170, 170, 170, 0.3);
      &.active {
        background-color: #aaaaaa;
      }
    }
  }

  .carousel-inner {
    width: 100%;
    margin: 0 auto;
    height: 100%;
    .carousel-item {
      height: 100%;

      img {
        max-width: 100%;
        /* height: 100%; */
        height: auto;
        max-height: 100%;
        object-fit: cover;
      }
      &.active {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      }
    }
  }

  video {
    border-radius: 20px;
    max-width: 100%;
    max-height: 100%;
  }

  .carousel-item-start {
    display: none;
    transition: transform 0.6s ease;
  }

  .carousel-dummy-image {
    height: 100%;
    width: 100%;
    max-width: 254px;
    border-radius: 20px;
    object-fit: contain;
  }

  &.option-carousel-wrapper {
    margin: 0 auto;
    height: auto;
    width: 100%;
    .carousel.slide {
      position: relative;
      /* width: 80%; */
      margin: 0 auto;
      height: 100%;
    }

    .carousel-inner {
      width: 100%;
      height: 100% !important;
    }

    .carousel-indicators {
      position: absolute;
      top: 50%;
      left: 0;
      transform: translate(-50px, 0);
      bottom: unset;
      right: unset;
      margin: 0px;
      /* display: none; */
      /* neww CSS */
      top: unset;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 0%);
      right: unset;
    }
  }
  &.carousel-dummy-image {
    height: auto !important;
    max-height: 200px !important;
    img {
      height: 100%;
      width: 100%;
      max-width: 254px;
      border-radius: 20px;
      object-fit: contain;
    }
  }
  &.donation-ad-carousel {
    overflow: unset;
    .carousel-inner .carousel-item {
      img {
        max-height: 200px;
      }
    }
  }

  &.single-media-caraousel {
    max-height: 200px;
    height: auto;
    .carousel-indicators {
      display: none !important;
    }
    img {
      object-fit: contain;
    }
  }
  @media (min-width: 280px) and (max-width: 1200px) {
    /* height: 100px !important; */
    margin-top: 0px;
    .carousel-inner {
      max-width: 300px !important;
      .carousel-item {
        &.active {
          display: inline-block;
        }
      }
    }
    .carousel.slide {
      width: 100% !important;
      text-align: center;
    }
  }

`;

const CarouselComponent: React.FC<CarouselProps> = ({ media, className }) => {
  if (!media || media.length === 0) {
    return (
      <>
        {/* <CustomCarouselWrapper className={`carousel-dummy-image ${className}`}>
              <img className="carousel-dummy-image" src={dummyImage} alt={`Slide`} />
          </CustomCarouselWrapper> */}
      </>
    );
  }

  return (
    <CustomCarouselWrapper className={`${className}`}>
      <Carousel interval={3000} controls={false}>
        {media.map((item, index) => (
          <Carousel.Item key={index}>
            {item.type === "Image" && (
              <>
                <img
                  className=""
                  src={item.fullURL}
                  alt={`Slide ${index}`}
                  style={{ borderRadius: "4px" }}
                />
              </>
            )}
            {item.type === "Video" && <Video url={item.fullURL} />}
          </Carousel.Item>
        ))}
      </Carousel>
    </CustomCarouselWrapper>
  );
};

export default CarouselComponent;
